import styled, { css } from 'styled-components';

import { pxToRem, StatusColor } from 'utils/scss';

export const BackLink = styled.span`
  display: flex;
  justify-content: flex-start;
  // width: ${pxToRem('180px')};
  height: ${pxToRem('40px')};
  margin-top: ${pxToRem('2px')};
  background-image: linear-gradient(243deg, #49b696 86%, #48bab9 15%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${pxToRem('40px')};
`;
export const LeadTitle = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${pxToRem('16px')};
`;
export const LeadSubTitle = styled.div`
  display: flex;
  height: ${pxToRem('48px')};
  justify-content: ${props => (props.isListClosed ? '' : 'space-between')};
`;
export const HistoryListButton = styled.div`
  height: ${pxToRem('48px')};
  width: ${pxToRem('195px')};
  position: absolute;
  right: ${pxToRem('0px')};
  background-color: ${props => props.theme.colors.white};
  text-transform: uppercase;
  border: none;
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.statusGreen};
  cursor: pointer;
  border-radius: ${pxToRem('24px')} ${pxToRem('0px')} ${pxToRem('0px')}
    ${pxToRem('24px')};
  box-shadow: ${pxToRem('11px')} ${pxToRem('11px')} ${pxToRem('22px')}
    ${pxToRem('-5px')} rgba(7, 11, 21, 0.08);

  > span:nth-child(2) {
    padding: ${pxToRem('16px')} 0;
  }
`;

export const HistoryIcon = styled.span`
  font-size: ${pxToRem('32px')};
  color: inherit;
  margin: ${pxToRem('8px')} ${pxToRem('14px')} ${pxToRem('8px')}
    ${pxToRem('8px')};
`;
export const IconElement = styled.span`
  font-size: ${pxToRem('12px')};
  margin-right: ${pxToRem('8px')};
`;

export const StatusLead = styled.span`
  margin-left: ${pxToRem('40px')};
  ${props => props.value && StatusColor(props.value)}
  border-radius: ${pxToRem('20px')};
  padding: ${pxToRem('6px')} ${pxToRem('24px')};
  height: ${pxToRem('28px')};
  font-size: ${pxToRem('12px')};
  font-weight: bold;
  text-transform: uppercase;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: ${pxToRem('2px')};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.theme.colors.white};
  margin-top: ${pxToRem('40px')};
  padding: ${pxToRem('24px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} #ececed;
`;
export const DetailsTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const DetailsDataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
export const DetaildDataItem = styled.div`
  flex: 1 0 20%;
  min-width: ${pxToRem('205px')};
  max-width: ${pxToRem('212px')};
`;
export const ItemTitle = styled.div`
  margin: ${pxToRem('24px')} 0 ${pxToRem('8px')} 0;
  color: ${props => props.theme.colors.grayText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;
export const Item = styled.div``;
export const ContentWrapper = styled.div``;
export const LastConfiguration = styled.div`
  margin: ${pxToRem('15px')};
  text-align: end;
  margin-top: ${pxToRem('40px')};
`;
export const NotAvailable = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  margin-top: ${pxToRem('40px')};
  padding: ${pxToRem('24px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} #ececed;
  align-items: center;
  justify-content: center;
`;

export const ExternalGridContainer = styled.div`
  margin-top: ${pxToRem('20px')};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.isNoteSection ? 'auto' : 'repeat(4, 1fr)'};
  margin-top: ${pxToRem('20px')};
  gap: ${pxToRem('38px')};
  align-items: center;
  ${props =>
    !props.productPreferences &&
    css`
      & > div {
        place-self: baseline;
        width: 100%;
      }
    `}
`;

export const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AddIconWrapper = styled.div`
  width: ${pxToRem('32px')};
  height: ${pxToRem('32px')};
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${pxToRem('1px')} solid ${props => props.theme.colors.statusGreen};
  border-radius: 50%;
  border-image-slice: 1;
  cursor: pointer;
`;

export const ButtonSave = styled.button`
  background-color: transparent;
  border: none;
  color: ${props => props.theme.colors.mainBlue};
  font-family: OpenSans;
  font-size: ${pxToRem('14px')};
  line-height: 1.43;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${pxToRem('8px')};

  ${props =>
    props.disabled &&
    css`
    color: ${props.theme.colors.fadedGray}
    cursor: not-allowed;
  `}
`;

export const FormInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem('42px')};
`;
